import React from 'react';
import { Box, ButtonNew, Heading, Text, Modal } from 'components/Wrapped';
import { CryptoIcon } from 'components/CryptoIcon';
import { formatNumberToPlaces } from 'utils';

const ConfirmOrderModal = ({
  orderType,
  price,
  tradeMode,
  baseCurrency,
  quoteCurrency,
  amount,
  visible = false,
  onToggleModal = () => {},
  onСonfirmButtonClick = () => {},
}) => {
  return (
    <Modal show={visible} toggleModal={onToggleModal} width="medium" pad="30px">
      <Box pad="none" gap="24px">
        <Heading level={2} size="16px">
          Подтверждение ордера
        </Heading>
        <Box pad="none">
          <Box pad="none" direction="row" align="center" gap="8px" margin={{ bottom: '20px' }}>
            <CryptoIcon currency={baseCurrency} margin="0px" style={{ height: '24px', width: '24px' }} />
            <Text color="white" size="18px" weight={500}>
              {baseCurrency}/{quoteCurrency}
            </Text>
            <Box background="rgba(255, 255, 255, 0.1)" round="6px" pad="10px">
              {tradeMode === 'BUY' ? (
                <Text color="#46B08E" size="12px" weight={600} style={{ lineHeight: '15px' }}>
                  Купить
                </Text>
              ) : (
                <Text color="#E56150" size="12px" weight={600} style={{ lineHeight: '15px' }}>
                  Продать
                </Text>
              )}
            </Box>
          </Box>
          <Box pad="none" direction="row" justify="between" margin={{ bottom: '12px' }}>
            <Text color="#B4B6B7" size="14px" weight={500}>
              Тип
            </Text>
            <Text color="#ffffff" size="14px" weight={500}>
              {orderType}
            </Text>
          </Box>
          <Box pad="none" direction="row" justify="between">
            <Text color="#B4B6B7" size="14px" weight={500}>
              Цена
            </Text>
            <Text color="#ffffff" size="14px" weight={500}>
              {price} {quoteCurrency}
            </Text>
          </Box>
          <Box background="#38444A" width="100%" height="2px" pad="none" margin={{ vertical: '16px' }} />
          <Box pad="none" direction="row" justify="between" align="center">
            <Text color="#B4B6B7" size="14px" weight={500}>
              Количество
            </Text>
            <Box pad="none" direction="row" align="baseline" gap="8px">
              <Text color="#ffffff" size="24px" weight={500}>
                {formatNumberToPlaces(amount, 2)}
              </Text>
              <Text color="#ffffff" size="18px" weight={500}>
                {baseCurrency}
              </Text>
            </Box>
          </Box>
        </Box>
        <ButtonNew
          theme="white"
          fill={true}
          style={{
            padding: '15px',
            fontSize: '16px',
            lineHeight: '20px',
          }}
          label="Подтвердить"
          onClick={onСonfirmButtonClick}
        />
      </Box>
    </Modal>
  );
};

export default ConfirmOrderModal;
